import {AfterViewInit, Component, Input} from '@angular/core';
import {SynopticsService} from '../../../services/synoptics.service';
import {SynopticFile} from '../../../model/synoptics/synoptic-file';

@Component({
  selector: 'app-synoptic-thumbnail',
  templateUrl: './synoptic-thumbnail.component.html',
  styleUrls: ['./synoptic-thumbnail.component.scss']
})
export class SynopticThumbnailComponent implements AfterViewInit {

  @Input() file: SynopticFile;
  @Input() alt: string;

  public thumbnail: any;


  constructor(
    private synopticsService: SynopticsService,
  ) {
  }

  ngAfterViewInit(): void {
    this.loadThumbnail();
  }

  private async loadThumbnail(): Promise<void> {
    this.thumbnail = await this.synopticsService.createThumbnail(this.file.data);
  }

}
